// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"GenericPage_imageContainer__xhkCh","divider":"GenericPage_divider__xsna4"};